export default "__VITE_ASSET__CDerm$Q3__"